import { Menu } from "@mui/material";
import type { DropDownMenuItemProps } from "@/shared/components/generic/dropdown-menu/DropDownMenuItem.tsx";
import DropDownMenuItem from "@/shared/components/generic/dropdown-menu/DropDownMenuItem.tsx";
import type { ReactNode } from "react";

export interface Props {
  open: boolean;
  verticalAnchorOrigin?: "top" | "center" | "bottom";
  horizontalAnchorOrigin?: "center" | "left" | "right";
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  menuItemProps: DropDownMenuItemProps[];
  paperClassName?: string;
  listClassName?: string;
}

export default function DropDownMenu({
  open,
  verticalAnchorOrigin = "bottom",
  horizontalAnchorOrigin = "right",
  anchorEl,
  handleClose,
  menuItemProps,
  paperClassName,
  listClassName,
}: Props): ReactNode {
  return (
    <Menu
      transitionDuration={200}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: verticalAnchorOrigin,
        horizontal: horizontalAnchorOrigin,
      }}
      slotProps={{
        paper: { className: paperClassName },
        list: { className: listClassName },
      }}
    >
      {menuItemProps.map((menuItemProp, idx) => (
        <DropDownMenuItem
          key={`menu_item_prop_${idx}`}
          selected={menuItemProp.selected}
          onClick={menuItemProp.onClick}
          label={menuItemProp.label}
          icon={menuItemProp.icon}
          active={menuItemProp.active}
        />
      ))}
    </Menu>
  );
}
